import { init } from '@nosto/preact'

import serpComponent from './serp'
import categoryComponent from './category'
import autocompleteComponent from './autocomplete'
import historyComponent from './history'
import { defaultConfig } from './config'
import { unbindOriginalSearch, getSizeFromPageUrlParam, getPaginationValues } from "./helpers"

import './styles/index.css'

unbindOriginalSearch('form[action="/search"]')

const catDiv = document.querySelector(".nosto_category");
let catId;

if (catDiv?.querySelector(".id")) {
    catId = catDiv?.querySelector(".id").textContent
} else {
    catId = catDiv?.querySelector(".id > a").textContent
}

// const sizeFromPages = getSizeFromPageUrlParam();
const { size = defaultConfig?.serpSize, from = 0 } = getPaginationValues() || {};

init({
    ...window.nostoTemplatesConfig,
    serpComponent,
    autocompleteComponent,
    historyComponent,
    categoryComponent,
    inputCssSelector: '#DesktopSearch, #MobileSearch',
    contentCssSelector: '#content',
    serpPath: "/search",
    serpUrlMapping: {
        query: 'q',
    },
    serpQuery: {
        products: {
            fields: [
                'productId', 'available', 'url', 'name', 'imageUrl', 'thumbUrl', 'description', 'brand', 'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount', 'customFields.key', 'customFields.value', 'tags1', 'skus.id', 'skus.customFields.key', 'skus.customFields.value'
            ],
            facets: ['*'],
            size: size,
            from: from,
        },
    },
    autocompleteQuery: {
        products: {
            fields: [
                'productId', 'available' ,'url', 'name', 'imageUrl', 'thumbUrl', 'brand', 'availability', 'price', 'priceText', 'listPrice', 'ratingValue', 'reviewCount', 'customFields.key', 'customFields.value', 'tags1', 'skus.id'
            ],
            size: defaultConfig.autocompleteSize,
        },
        keywords: {
            fields: [
                'keyword', '_highlight.keyword'
            ],
            facets: ['*'],
            size: defaultConfig.autocompleteKeywordsSize
        }
    },
    categoryCssSelector: '#nosto-category-merchandising',
    // isCategoryPage: () => location.pathname.includes('/collections/'),
    categoryQuery: () => {
        return {
            name: 'serp',
            products: {
                categoryId: catId,
                size: size,
                from: from,
            }
        }
    },
}).then(() => {
    const isMobile = window.innerWidth < 769;
    const nativePagination = document.querySelector(".container .pagination-row");

    if (nativePagination) {
        nativePagination.remove()
    }

    if (isMobile) {
        let input = document.querySelector("#MobileSearch");

        input.addEventListener("keydown", function (e) {
            if (e.key == "Enter") {
                e.preventDefault();
                input.blur()
            }
        })
    }
})